import { Injectable } from '@angular/core';
import { EsAuthor } from '../../../models/EsAuthor';
import { createAction, props, Store } from '@ngrx/store';

export class UsersSupervisedActionConstant {
  static readonly LOAD_USERS_SUPERVISED_STARTED = '[UserObjects]: LOAD_USERS_SUPERVISED_STARTED';
  static readonly LOAD_USERS_SUPERVISED_SUCCEEDED = '[UserObjects]: LOAD_USERS_SUPERVISED_SUCCEEDED';
  static readonly LOAD_USERS_SUPERVISED_FAILED = '[UserObjects]: LOAD_USERS_SUPERVISED_FAILED';
}

export const loadUsersSupervisedStartedAction = createAction(UsersSupervisedActionConstant.LOAD_USERS_SUPERVISED_STARTED);
export const loadUsersSupervisedSucceedAction = createAction(UsersSupervisedActionConstant.LOAD_USERS_SUPERVISED_SUCCEEDED, props<{payload: EsAuthor[]}>());
export const loafUsersSupervisedFailedAction = createAction(UsersSupervisedActionConstant.LOAD_USERS_SUPERVISED_FAILED, props<{error: Error}>());

@Injectable({
  providedIn: 'root'
})
export class UsersSupervisedAction {
  public static readonly _ALL = '_all';

  constructor(private localStore: Store ) {
  }

  public loadUsersSupervisedStart(): void {
    this.localStore.dispatch(loadUsersSupervisedStartedAction());
  }

  public loadUsersSupervisedSucceeded(payload: EsAuthor[]): void {
    this.localStore.dispatch(loadUsersSupervisedSucceedAction({payload}));
  }

  public loadUsersSupervisedFailed(error: any) {
    this.localStore.dispatch(loafUsersSupervisedFailedAction({error}));
  }
}
